<script setup lang="ts"></script>

<template>
  <div class="flex justify-center items-center">
    <div class="spinner"></div>
  </div>
</template>

<style scoped>
.spinner {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  position: relative;
  background: linear-gradient(0deg, rgba(85, 159, 255, 0.2) 33%, #0479ff 100%);
}
.spinner::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 85px;
  height: 85px;
  border-radius: 50%;
  background: white;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
